//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AuthorizedApiClientBase } from "../../../../components/Auth/AuthorizedApiClientBase";

export class WealthMappingClient extends AuthorizedApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    propelleWaitlistEndpointsPushCustomersToHubspot(request: PropelleWaitlistEndpointsPushCustomersToHubspot_Request): Promise<any> {
        let url_ = this.baseUrl + "/api/wealth-mapping/push-multiple-to-hubspot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPropelleWaitlistEndpointsPushCustomersToHubspot(_response);
        });
    }

    protected processPropelleWaitlistEndpointsPushCustomersToHubspot(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    calculateFutureValue(request: CalculateFutureValue_Request): Promise<CalculateFutureValue_Response> {
        let url_ = this.baseUrl + "/api/wealth-mapping/calculate-future-value";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculateFutureValue(_response);
        });
    }

    protected processCalculateFutureValue(response: Response): Promise<CalculateFutureValue_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateFutureValue_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalculateFutureValue_Response>(null as any);
    }

    /**
     * @return Success
     */
    calculateOwnedFutureValue(request: CalculateFutureValue_Request): Promise<CalculateFutureValue_Response> {
        let url_ = this.baseUrl + "/api/wealth-mapping/calculate-owned-future-value";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculateOwnedFutureValue(_response);
        });
    }

    protected processCalculateOwnedFutureValue(response: Response): Promise<CalculateFutureValue_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateFutureValue_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalculateFutureValue_Response>(null as any);
    }

    /**
     * @return Success
     */
    createOwnedWealthPicture(request: CreateWealthPicture_Request): Promise<CreateWealthPicture_Response> {
        let url_ = this.baseUrl + "/api/wealth-mapping/owned-wealth-picture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateOwnedWealthPicture(_response);
        });
    }

    protected processCreateOwnedWealthPicture(response: Response): Promise<CreateWealthPicture_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateWealthPicture_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateWealthPicture_Response>(null as any);
    }

    /**
     * @return Success
     */
    createWealthPicture(request: CreateWealthPicture_Request): Promise<CreateWealthPicture_Response> {
        let url_ = this.baseUrl + "/api/wealth-mapping/wealth-picture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateWealthPicture(_response);
        });
    }

    protected processCreateWealthPicture(response: Response): Promise<CreateWealthPicture_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateWealthPicture_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateWealthPicture_Response>(null as any);
    }

    /**
     * @return Success
     */
    deleteCustomer(userId: string | null): Promise<any> {
        let url_ = this.baseUrl + "/api/wealth-mapping/{UserId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{UserId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCustomer(_response);
        });
    }

    protected processDeleteCustomer(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    getPreviousWealthPicture(): Promise<GetPreviousWealthPicture_Response> {
        let url_ = this.baseUrl + "/api/wealth-mapping/previous-wealth-picture";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPreviousWealthPicture(_response);
        });
    }

    protected processGetPreviousWealthPicture(response: Response): Promise<GetPreviousWealthPicture_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPreviousWealthPicture_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPreviousWealthPicture_Response>(null as any);
    }

    /**
     * @return Success
     */
    getWealthMappingOverview(): Promise<GetWealthMappingOverview_Response> {
        let url_ = this.baseUrl + "/api/wealth-mapping/overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWealthMappingOverview(_response);
        });
    }

    protected processGetWealthMappingOverview(response: Response): Promise<GetWealthMappingOverview_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWealthMappingOverview_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetWealthMappingOverview_Response>(null as any);
    }
}

export class PropelleWaitlistEndpointsPushCustomersToHubspot_Request implements IPropelleWaitlistEndpointsPushCustomersToHubspot_Request {
    anonymousWealthPictureIds?: string[] | undefined;

    constructor(data?: IPropelleWaitlistEndpointsPushCustomersToHubspot_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["anonymousWealthPictureIds"])) {
                this.anonymousWealthPictureIds = [] as any;
                for (let item of _data["anonymousWealthPictureIds"])
                    this.anonymousWealthPictureIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PropelleWaitlistEndpointsPushCustomersToHubspot_Request {
        data = typeof data === 'object' ? data : {};
        let result = new PropelleWaitlistEndpointsPushCustomersToHubspot_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.anonymousWealthPictureIds)) {
            data["anonymousWealthPictureIds"] = [];
            for (let item of this.anonymousWealthPictureIds)
                data["anonymousWealthPictureIds"].push(item);
        }
        return data;
    }
}

export interface IPropelleWaitlistEndpointsPushCustomersToHubspot_Request {
    anonymousWealthPictureIds?: string[] | undefined;
}

export class CalculateFutureValue_Response implements ICalculateFutureValue_Response {
    performsWell?: number;
    performsOK?: number;
    performsBadly?: number;

    constructor(data?: ICalculateFutureValue_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.performsWell = _data["performsWell"];
            this.performsOK = _data["performsOK"];
            this.performsBadly = _data["performsBadly"];
        }
    }

    static fromJS(data: any): CalculateFutureValue_Response {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateFutureValue_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["performsWell"] = this.performsWell;
        data["performsOK"] = this.performsOK;
        data["performsBadly"] = this.performsBadly;
        return data;
    }
}

export interface ICalculateFutureValue_Response {
    performsWell?: number;
    performsOK?: number;
    performsBadly?: number;
}

export class CalculateFutureValue_Request implements ICalculateFutureValue_Request {
    prospectiveUserId?: string | undefined;
    initialDeposit?: number | undefined;
    monthlyDeposit?: number | undefined;
    years?: number;
    desiredReturn?: number | undefined;

    constructor(data?: ICalculateFutureValue_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prospectiveUserId = _data["prospectiveUserId"];
            this.initialDeposit = _data["initialDeposit"];
            this.monthlyDeposit = _data["monthlyDeposit"];
            this.years = _data["years"];
            this.desiredReturn = _data["desiredReturn"];
        }
    }

    static fromJS(data: any): CalculateFutureValue_Request {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateFutureValue_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prospectiveUserId"] = this.prospectiveUserId;
        data["initialDeposit"] = this.initialDeposit;
        data["monthlyDeposit"] = this.monthlyDeposit;
        data["years"] = this.years;
        data["desiredReturn"] = this.desiredReturn;
        return data;
    }
}

export interface ICalculateFutureValue_Request {
    prospectiveUserId?: string | undefined;
    initialDeposit?: number | undefined;
    monthlyDeposit?: number | undefined;
    years?: number;
    desiredReturn?: number | undefined;
}

export class CreateWealthPicture_Response implements ICreateWealthPicture_Response {
    lumpSumRequired?: number;

    constructor(data?: ICreateWealthPicture_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lumpSumRequired = _data["lumpSumRequired"];
        }
    }

    static fromJS(data: any): CreateWealthPicture_Response {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWealthPicture_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lumpSumRequired"] = this.lumpSumRequired;
        return data;
    }
}

export interface ICreateWealthPicture_Response {
    lumpSumRequired?: number;
}

export class CreateWealthPicture_Request implements ICreateWealthPicture_Request {
    prospectiveUserId?: string | undefined;
    age?: number;
    emailAddress?: string | undefined;
    gender!: CreateWealthPicture_Request_GivenGender;
    financialIndependence?: CreateWealthPicture_Request_FinancialIndependenceRequest | undefined;
    financialSecurity?: CreateWealthPicture_Request_FinancialSecurityRequest | undefined;
    qualityOfLife?: CreateWealthPicture_Request_QualityOfLifeRequest | undefined;
    specificEvent?: CreateWealthPicture_Request_SpecificEventRequest | undefined;
    retirement?: CreateWealthPicture_Request_RetirementRequest | undefined;

    constructor(data?: ICreateWealthPicture_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prospectiveUserId = _data["prospectiveUserId"];
            this.age = _data["age"];
            this.emailAddress = _data["emailAddress"];
            this.gender = _data["gender"];
            this.financialIndependence = _data["financialIndependence"] ? CreateWealthPicture_Request_FinancialIndependenceRequest.fromJS(_data["financialIndependence"]) : <any>undefined;
            this.financialSecurity = _data["financialSecurity"] ? CreateWealthPicture_Request_FinancialSecurityRequest.fromJS(_data["financialSecurity"]) : <any>undefined;
            this.qualityOfLife = _data["qualityOfLife"] ? CreateWealthPicture_Request_QualityOfLifeRequest.fromJS(_data["qualityOfLife"]) : <any>undefined;
            this.specificEvent = _data["specificEvent"] ? CreateWealthPicture_Request_SpecificEventRequest.fromJS(_data["specificEvent"]) : <any>undefined;
            this.retirement = _data["retirement"] ? CreateWealthPicture_Request_RetirementRequest.fromJS(_data["retirement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateWealthPicture_Request {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWealthPicture_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prospectiveUserId"] = this.prospectiveUserId;
        data["age"] = this.age;
        data["emailAddress"] = this.emailAddress;
        data["gender"] = this.gender;
        data["financialIndependence"] = this.financialIndependence ? this.financialIndependence.toJSON() : <any>undefined;
        data["financialSecurity"] = this.financialSecurity ? this.financialSecurity.toJSON() : <any>undefined;
        data["qualityOfLife"] = this.qualityOfLife ? this.qualityOfLife.toJSON() : <any>undefined;
        data["specificEvent"] = this.specificEvent ? this.specificEvent.toJSON() : <any>undefined;
        data["retirement"] = this.retirement ? this.retirement.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateWealthPicture_Request {
    prospectiveUserId?: string | undefined;
    age?: number;
    emailAddress?: string | undefined;
    gender: CreateWealthPicture_Request_GivenGender;
    financialIndependence?: CreateWealthPicture_Request_FinancialIndependenceRequest | undefined;
    financialSecurity?: CreateWealthPicture_Request_FinancialSecurityRequest | undefined;
    qualityOfLife?: CreateWealthPicture_Request_QualityOfLifeRequest | undefined;
    specificEvent?: CreateWealthPicture_Request_SpecificEventRequest | undefined;
    retirement?: CreateWealthPicture_Request_RetirementRequest | undefined;
}

export enum CreateWealthPicture_Request_GivenGender {
    Woman = "Woman",
    TransgenderWoman = "TransgenderWoman",
    Man = "Man",
    TransgenderMan = "TransgenderMan",
    NonBinary = "NonBinary",
    NotListed = "NotListed",
    NotSpecified = "NotSpecified",
}

export class CreateWealthPicture_Request_FinancialIndependenceRequest implements ICreateWealthPicture_Request_FinancialIndependenceRequest {
    percentageWorkReduction?: number;
    years?: number;
    currentGrossSalary?: number;

    constructor(data?: ICreateWealthPicture_Request_FinancialIndependenceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentageWorkReduction = _data["percentageWorkReduction"];
            this.years = _data["years"];
            this.currentGrossSalary = _data["currentGrossSalary"];
        }
    }

    static fromJS(data: any): CreateWealthPicture_Request_FinancialIndependenceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWealthPicture_Request_FinancialIndependenceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentageWorkReduction"] = this.percentageWorkReduction;
        data["years"] = this.years;
        data["currentGrossSalary"] = this.currentGrossSalary;
        return data;
    }
}

export interface ICreateWealthPicture_Request_FinancialIndependenceRequest {
    percentageWorkReduction?: number;
    years?: number;
    currentGrossSalary?: number;
}

export class CreateWealthPicture_Request_FinancialSecurityRequest implements ICreateWealthPicture_Request_FinancialSecurityRequest {
    target?: number;
    years?: number;

    constructor(data?: ICreateWealthPicture_Request_FinancialSecurityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.target = _data["target"];
            this.years = _data["years"];
        }
    }

    static fromJS(data: any): CreateWealthPicture_Request_FinancialSecurityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWealthPicture_Request_FinancialSecurityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["target"] = this.target;
        data["years"] = this.years;
        return data;
    }
}

export interface ICreateWealthPicture_Request_FinancialSecurityRequest {
    target?: number;
    years?: number;
}

export class CreateWealthPicture_Request_QualityOfLifeRequest implements ICreateWealthPicture_Request_QualityOfLifeRequest {
    extraMonthlyIncome?: number;
    years?: number;

    constructor(data?: ICreateWealthPicture_Request_QualityOfLifeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extraMonthlyIncome = _data["extraMonthlyIncome"];
            this.years = _data["years"];
        }
    }

    static fromJS(data: any): CreateWealthPicture_Request_QualityOfLifeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWealthPicture_Request_QualityOfLifeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extraMonthlyIncome"] = this.extraMonthlyIncome;
        data["years"] = this.years;
        return data;
    }
}

export interface ICreateWealthPicture_Request_QualityOfLifeRequest {
    extraMonthlyIncome?: number;
    years?: number;
}

export class CreateWealthPicture_Request_SpecificEventRequest implements ICreateWealthPicture_Request_SpecificEventRequest {
    description!: string;
    target?: number;
    years?: number;

    constructor(data?: ICreateWealthPicture_Request_SpecificEventRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.target = _data["target"];
            this.years = _data["years"];
        }
    }

    static fromJS(data: any): CreateWealthPicture_Request_SpecificEventRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWealthPicture_Request_SpecificEventRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["target"] = this.target;
        data["years"] = this.years;
        return data;
    }
}

export interface ICreateWealthPicture_Request_SpecificEventRequest {
    description: string;
    target?: number;
    years?: number;
}

export class CreateWealthPicture_Request_RetirementRequest implements ICreateWealthPicture_Request_RetirementRequest {
    salary?: number;

    constructor(data?: ICreateWealthPicture_Request_RetirementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salary = _data["salary"];
        }
    }

    static fromJS(data: any): CreateWealthPicture_Request_RetirementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWealthPicture_Request_RetirementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salary"] = this.salary;
        return data;
    }
}

export interface ICreateWealthPicture_Request_RetirementRequest {
    salary?: number;
}

export class GetPreviousWealthPicture_Response implements IGetPreviousWealthPicture_Response {
    gender?: PropelleWealthMappingCoreApplicationDomainWealthPictureGender;

    constructor(data?: IGetPreviousWealthPicture_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): GetPreviousWealthPicture_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetPreviousWealthPicture_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gender"] = this.gender;
        return data;
    }
}

export interface IGetPreviousWealthPicture_Response {
    gender?: PropelleWealthMappingCoreApplicationDomainWealthPictureGender;
}

export enum PropelleWealthMappingCoreApplicationDomainWealthPictureGender {
    Woman = 1,
    TransgenderWoman = 2,
    Man = 3,
    TransgenderMan = 4,
    NonBinary = 5,
    NotListed = 6,
    NotSpecified = 7,
}

export class GetWealthMappingOverview_Response implements IGetWealthMappingOverview_Response {
    futureValueCalculation?: GetWealthMappingOverview_Response_FutureValueCalculationResponse | undefined;
    wealthPicture?: GetWealthMappingOverview_Response_WealthPictureResponse | undefined;

    constructor(data?: IGetWealthMappingOverview_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.futureValueCalculation = _data["futureValueCalculation"] ? GetWealthMappingOverview_Response_FutureValueCalculationResponse.fromJS(_data["futureValueCalculation"]) : <any>undefined;
            this.wealthPicture = _data["wealthPicture"] ? GetWealthMappingOverview_Response_WealthPictureResponse.fromJS(_data["wealthPicture"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["futureValueCalculation"] = this.futureValueCalculation ? this.futureValueCalculation.toJSON() : <any>undefined;
        data["wealthPicture"] = this.wealthPicture ? this.wealthPicture.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response {
    futureValueCalculation?: GetWealthMappingOverview_Response_FutureValueCalculationResponse | undefined;
    wealthPicture?: GetWealthMappingOverview_Response_WealthPictureResponse | undefined;
}

export class GetWealthMappingOverview_Response_FutureValueCalculationResponse implements IGetWealthMappingOverview_Response_FutureValueCalculationResponse {
    inputs?: GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationInputs | undefined;
    outputs?: GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationOutputs | undefined;

    constructor(data?: IGetWealthMappingOverview_Response_FutureValueCalculationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputs = _data["inputs"] ? GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationInputs.fromJS(_data["inputs"]) : <any>undefined;
            this.outputs = _data["outputs"] ? GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationOutputs.fromJS(_data["outputs"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_FutureValueCalculationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_FutureValueCalculationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputs"] = this.inputs ? this.inputs.toJSON() : <any>undefined;
        data["outputs"] = this.outputs ? this.outputs.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_FutureValueCalculationResponse {
    inputs?: GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationInputs | undefined;
    outputs?: GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationOutputs | undefined;
}

export class GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationInputs implements IGetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationInputs {
    initialDeposit?: number | undefined;
    monthlyDeposit?: number | undefined;
    years?: number;
    desiredReturn?: number;

    constructor(data?: IGetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationInputs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initialDeposit = _data["initialDeposit"];
            this.monthlyDeposit = _data["monthlyDeposit"];
            this.years = _data["years"];
            this.desiredReturn = _data["desiredReturn"];
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationInputs {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationInputs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialDeposit"] = this.initialDeposit;
        data["monthlyDeposit"] = this.monthlyDeposit;
        data["years"] = this.years;
        data["desiredReturn"] = this.desiredReturn;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationInputs {
    initialDeposit?: number | undefined;
    monthlyDeposit?: number | undefined;
    years?: number;
    desiredReturn?: number;
}

export class GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationOutputs implements IGetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationOutputs {
    performsWell?: number;
    performsOK?: number;
    performsBadly?: number;

    constructor(data?: IGetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationOutputs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.performsWell = _data["performsWell"];
            this.performsOK = _data["performsOK"];
            this.performsBadly = _data["performsBadly"];
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationOutputs {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationOutputs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["performsWell"] = this.performsWell;
        data["performsOK"] = this.performsOK;
        data["performsBadly"] = this.performsBadly;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_FutureValueCalculationResponse_FutureValueCalculationOutputs {
    performsWell?: number;
    performsOK?: number;
    performsBadly?: number;
}

export class GetWealthMappingOverview_Response_WealthPictureResponse implements IGetWealthMappingOverview_Response_WealthPictureResponse {
    outputs?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureOutputs | undefined;
    inputs?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs | undefined;

    constructor(data?: IGetWealthMappingOverview_Response_WealthPictureResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.outputs = _data["outputs"] ? GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureOutputs.fromJS(_data["outputs"]) : <any>undefined;
            this.inputs = _data["inputs"] ? GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs.fromJS(_data["inputs"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_WealthPictureResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_WealthPictureResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outputs"] = this.outputs ? this.outputs.toJSON() : <any>undefined;
        data["inputs"] = this.inputs ? this.inputs.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_WealthPictureResponse {
    outputs?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureOutputs | undefined;
    inputs?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs | undefined;
}

export class GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureOutputs implements IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureOutputs {
    lumpSumRequired?: number;
    goal?: GetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse | undefined;
    years?: number;

    constructor(data?: IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureOutputs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lumpSumRequired = _data["lumpSumRequired"];
            this.goal = _data["goal"] ? GetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse.fromJS(_data["goal"]) : <any>undefined;
            this.years = _data["years"];
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureOutputs {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureOutputs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lumpSumRequired"] = this.lumpSumRequired;
        data["goal"] = this.goal ? this.goal.toJSON() : <any>undefined;
        data["years"] = this.years;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureOutputs {
    lumpSumRequired?: number;
    goal?: GetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse | undefined;
    years?: number;
}

export class GetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse implements IGetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse {
    customDescription?: string | undefined;
    type?: GetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse_GoalType;

    constructor(data?: IGetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customDescription = _data["customDescription"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customDescription"] = this.customDescription;
        data["type"] = this.type;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse {
    customDescription?: string | undefined;
    type?: GetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse_GoalType;
}

export enum GetWealthMappingOverview_Response_WealthPictureResponse_GoalResponse_GoalType {
    FinancialIndependence = "FinancialIndependence",
    FinancialSecurity = "FinancialSecurity",
    QualityOfLife = "QualityOfLife",
    SpecificEvent = "SpecificEvent",
    Retirement = "Retirement",
}

export class GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs implements IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs {
    age?: number;
    financialIndependence?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialIndependenceInputs | undefined;
    financialSecurity?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialSecurityInputs | undefined;
    qualityOfLife?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_QualityOfLifeInputs | undefined;
    specificEvent?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_SpecificEventInputs | undefined;
    retirement?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_RetirementInputs | undefined;

    constructor(data?: IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.age = _data["age"];
            this.financialIndependence = _data["financialIndependence"] ? GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialIndependenceInputs.fromJS(_data["financialIndependence"]) : <any>undefined;
            this.financialSecurity = _data["financialSecurity"] ? GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialSecurityInputs.fromJS(_data["financialSecurity"]) : <any>undefined;
            this.qualityOfLife = _data["qualityOfLife"] ? GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_QualityOfLifeInputs.fromJS(_data["qualityOfLife"]) : <any>undefined;
            this.specificEvent = _data["specificEvent"] ? GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_SpecificEventInputs.fromJS(_data["specificEvent"]) : <any>undefined;
            this.retirement = _data["retirement"] ? GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_RetirementInputs.fromJS(_data["retirement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["age"] = this.age;
        data["financialIndependence"] = this.financialIndependence ? this.financialIndependence.toJSON() : <any>undefined;
        data["financialSecurity"] = this.financialSecurity ? this.financialSecurity.toJSON() : <any>undefined;
        data["qualityOfLife"] = this.qualityOfLife ? this.qualityOfLife.toJSON() : <any>undefined;
        data["specificEvent"] = this.specificEvent ? this.specificEvent.toJSON() : <any>undefined;
        data["retirement"] = this.retirement ? this.retirement.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs {
    age?: number;
    financialIndependence?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialIndependenceInputs | undefined;
    financialSecurity?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialSecurityInputs | undefined;
    qualityOfLife?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_QualityOfLifeInputs | undefined;
    specificEvent?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_SpecificEventInputs | undefined;
    retirement?: GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_RetirementInputs | undefined;
}

export class GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialIndependenceInputs implements IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialIndependenceInputs {
    years?: number;
    percentageWorkReduction?: number;
    currentGrossSalary?: number;

    constructor(data?: IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialIndependenceInputs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.years = _data["years"];
            this.percentageWorkReduction = _data["percentageWorkReduction"];
            this.currentGrossSalary = _data["currentGrossSalary"];
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialIndependenceInputs {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialIndependenceInputs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["years"] = this.years;
        data["percentageWorkReduction"] = this.percentageWorkReduction;
        data["currentGrossSalary"] = this.currentGrossSalary;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialIndependenceInputs {
    years?: number;
    percentageWorkReduction?: number;
    currentGrossSalary?: number;
}

export class GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialSecurityInputs implements IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialSecurityInputs {
    target?: number;
    years?: number;

    constructor(data?: IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialSecurityInputs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.target = _data["target"];
            this.years = _data["years"];
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialSecurityInputs {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialSecurityInputs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["target"] = this.target;
        data["years"] = this.years;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_FinancialSecurityInputs {
    target?: number;
    years?: number;
}

export class GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_QualityOfLifeInputs implements IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_QualityOfLifeInputs {
    extraMonthlyIncome?: number;
    years?: number;

    constructor(data?: IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_QualityOfLifeInputs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extraMonthlyIncome = _data["extraMonthlyIncome"];
            this.years = _data["years"];
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_QualityOfLifeInputs {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_QualityOfLifeInputs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extraMonthlyIncome"] = this.extraMonthlyIncome;
        data["years"] = this.years;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_QualityOfLifeInputs {
    extraMonthlyIncome?: number;
    years?: number;
}

export class GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_SpecificEventInputs implements IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_SpecificEventInputs {
    description?: string | undefined;
    target?: number;
    years?: number;

    constructor(data?: IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_SpecificEventInputs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.target = _data["target"];
            this.years = _data["years"];
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_SpecificEventInputs {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_SpecificEventInputs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["target"] = this.target;
        data["years"] = this.years;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_SpecificEventInputs {
    description?: string | undefined;
    target?: number;
    years?: number;
}

export class GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_RetirementInputs implements IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_RetirementInputs {
    salary?: number;

    constructor(data?: IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_RetirementInputs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salary = _data["salary"];
        }
    }

    static fromJS(data: any): GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_RetirementInputs {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_RetirementInputs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salary"] = this.salary;
        return data;
    }
}

export interface IGetWealthMappingOverview_Response_WealthPictureResponse_WealthPictureInputs_RetirementInputs {
    salary?: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}